<template>
  <div class="Calendar">
    <span class="Modal-title" >Sélectionnez le jour et l’heure de 
      <template v-if="deliveryTypeWord !== ''">{{deliveryTypeWord}}</template>
      <template v-else>l'installation</template> 
    </span>
    <FullCalendar
      v-if="displayCalendar"
      class="Calendar"
      ref="fullCalendar"
      defaultView="timeGridWeek"
      :header="{
        left: 'prev',
        center: '',
        right: 'next',
      }"
      :hiddenDays="[0]"
      :slotDuration="'02:00:00'"
      :minTime="'08:00:00'"
      :maxTime="'22:00:00'"
      :plugins="calendarPlugins"
      :weekends="calendarWeekends"
      :locale="local"
      :allDaySlot="false"
      :defaultDate="agenciesData.firstDate"
      :firstDate="agenciesData.firstDate"
      :lastDate="agenciesData.lastDate"
      :selectedDate="agenciesData.selectedDate"
      :events="agenciesData.slots"
      :selectable="true"
      @eventClick="handleDateClick"
      @eventPositioned="eventRender"
    />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import frLocale from "@fullcalendar/core/locales/fr";
import EventBus from "@/event-bus";
import { mapGetters, mapActions } from "vuex";
import updateCartMixin from "@/mixins/actions/cart/updateCartMixin";

import "@/components/Calendar/Calendar.scss";

export default {
  name: "Calendar",
  mixins: [updateCartMixin],

  components: {
    FullCalendar,
  },

  props: {
    needReload: {
      type: Boolean,
      default: false,
    },
    updateModal: {
      type: Boolean,
      default: false,
    },
    deliveryTypeWord: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      calendar: null,
      calendarPlugins: [timeGridPlugin],
      calendarWeekends: true,
      displayCalendar: false,
      titleFormat: {
        month: "short",
      },
      local: frLocale,
    };
  },

  computed: {
    ...mapGetters({ 
      agenciesData: "getSelectedDeliveryCalendarData", 
      isZeborne: "isZeborne", 
      isLead: "isLead",
    }),
  },

  watch: {
    agenciesData() {  
      //Destroy FullCalendar Component to get first date when the agency change
      if(this.needReload) {
        this.displayCalendar = true;
      } else {
        this.displayCalendar = false;
      }

      if (this.$refs.fullCalendar) {
        this.calendar = this.$refs.fullCalendar.getApi();
      }
    },
  },

  mounted() {
    if (!this.needReload) {
      this.displayCalendar = true;
    }
  },
  
  updated() {
    //When Calendar only Update, destroy FullCalendar in Watch et re-create to get first date avalaible
    this.displayCalendar = true;
  },
  
  methods: {
    // ============== ON CLICK : CALENDAR ==================

    eventRender(info) {
      let segment = info.el.fcSeg;
      if (typeof info.el.fcSeg !== "undefined") {
        let additionalInfo = segment.eventRange.def.extendedProps.additionalInfo;
        if (additionalInfo) {
          info.el.innerHTML =
            info.el.innerHTML + "<span class='additionalInfo'>" + additionalInfo + "</span>";
          info.el.classList.add("asInnerInfo");
        }
      }
    },

    /** Handle click event */
    handleDateClick(event) {
      this.toogleEventClass(event);
      this.setDeliveryStoreData(event);
    },

    /** remove all selected event and add class on click to target event */
    toogleEventClass(event) {
      let selectedButtons = document.getElementsByClassName("selectedEvent");
      selectedButtons.forEach(element => {
        element.classList.remove("selectedEvent");
      });
      event.el.classList.add("selectedEvent");
    },

    /**
     * Set data for Store :
     * Delivery
     */
    setDeliveryStoreData(event) {
      if (!event.el.classList.contains("empty")) {
        let segment = event.el.fcSeg;

        let child = event.el;
        let parent = child.parentNode;
        var index = Array.prototype.indexOf.call(parent.children, child);
        /** Object delivery */
        let delivery = {
          start: segment.start,
          end: segment.end,
          interventionProductId: segment.eventRange.def.extendedProps.interventionProductId,
          agencyId: segment.eventRange.def.extendedProps.agencyId,
          selectedHours: segment.eventRange.def.title,
          slotId: index + 1,
          additionalInfo: segment.eventRange.def.extendedProps.additionalInfo,
        };

        let additionalInfo = 0;
        if (typeof delivery.additionalInfo !== "undefined") {
          additionalInfo = Number(delivery.additionalInfo.replace(/[+€]/g, "").replace(",", "."));
        }

        /** Call map Actions */
        this.setAdditionalInfo(additionalInfo);
        this.setDelivery(delivery);
        this.setPreprendCartInterventionSlots(this.isZeborne);

        this.$emit("Calendar::close");
        EventBus.$on("hide-dates-messages", () => (this.showSubmitMessages = true));
      }
    },

    // Map Actions
    ...mapActions(["setDelivery"]),
    ...mapActions(["setPreprendCartInterventionSlots"]),
    ...mapActions(["setAdditionalInfo"]),
  },
};
</script>
